import * as React from 'react';

import TranslationActions from 'actions/TranslationActions';
// @ts-ignore
import LanguageHoverCard from 'chat/components/LanguageHoverCard';
import errorLogger from 'utils/errorLogger';

import TooltipHovercardIconButton from './TooltipHovercardIconButton';
import { TranslationsHoverCard } from 'chat/components/MessageTranslations/TranslationsHoverCard';
import CurrentUser from 'auth/CurrentUser';
import { GetLanguageSet_translations_getLanguageSet_data_languageCounts as LanguageCounts } from 'translations/queries/__generated__/GetLanguageSet';
import { TranslatedMessagePayload } from 'translations/actions';
import { SuccessResponse } from 'translations/types';
import LayerTrigger from 'components/LayerTrigger';

export type Props = {
  onTextChange?: (text: string) => void;
  onLangChange?: (lang: string) => void;
  textToTranslate: string;
  className?: string;
  eventKey?: string;
  eventProperties?: { [key: string]: any };
  dataTestSelector?: string;
  languageCounts: LanguageCounts[];
  toggleTranslate: (shouldTranslate: boolean) => void;
  shouldTranslate: boolean;
  hasTargets: boolean;
  setTranslationPreview: (
    translateMessageResponse: SuccessResponse<TranslatedMessagePayload>
  ) => void;
  backToOriginalCallback: () => void;
  translationsPreviewActive: boolean;
};

class TranslateButton extends React.Component<Props> {
  handleTranslateTo = (
    lang: string,
    text: string,
    onTextChange?: (text: string) => void,
    onLangChange?: (lang: string) => void
  ) => {
    TranslationActions.translate(text, lang)
      .then(response => {
        if (onLangChange) {
          onLangChange(lang);
        }
        if (onTextChange) {
          onTextChange(response.translation);
        }
      })
      .catch(errorLogger('TranslateButton translate failed'));
  };

  hasNewTranslationsEnabled() {
    return CurrentUser?.getUser()?.hasFeature('2020.dec.preferred_language_translation_v0');
  }

  getUserPreferredLanguage() {
    const user = CurrentUser.getUser();
    if (user && user.getPreference('preferred_language')) {
      return user.getPreference('preferred_language');
    }
    return 'none';
  }

  render() {
    const {
      textToTranslate,
      shouldTranslate,
      onTextChange,
      onLangChange,
      languageCounts,
      toggleTranslate,
      hasTargets,
      setTranslationPreview,
      backToOriginalCallback,
      translationsPreviewActive,
      ...props
    } = this.props;

    const disabled = !hasTargets;
    return (
      <TooltipHovercardIconButton
        data-test="translate-button"
        icon="translation"
        layerPlacement="top"
        layerAlignment="left"
        disabled={disabled}
        switchedOn={shouldTranslate}
        layer={(layerTrigger: LayerTrigger) =>
          this.hasNewTranslationsEnabled() ? (
            <TranslationsHoverCard
              data-test="translations-hover-card"
              languageCounts={languageCounts}
              defaultLanguageCode={this.getUserPreferredLanguage()}
              toggleTranslate={toggleTranslate}
              shouldTranslate={shouldTranslate}
              textToTranslate={textToTranslate}
              setTranslationPreview={setTranslationPreview}
              translationsPreviewActive={translationsPreviewActive}
              backToOriginalCallback={backToOriginalCallback}
              toggleHoverCardVisibility={() => {
                layerTrigger.toggleLayer();
              }}
            />
          ) : (
            <LanguageHoverCard
              data-test="language-hover-card"
              onLanguagePicked={(lang: string) =>
                this.handleTranslateTo(lang, textToTranslate, onTextChange, onLangChange)
              }
              eventProperties={{
                composer_version: 'web_full_page',
              }}
            />
          )
        }
        tooltipText={disabled ? 'Type your message to translate it' : 'Translate'}
        controlled
        {...props}
      />
    );
  }
}

export default TranslateButton;
